


















import { Component, Prop, Watch, Vue, Model } from 'vue-property-decorator';

@Component
export default class MultiDropdownList extends Vue {
  @Model('update', { type: String, default: '' }) public select!: string[];
  @Prop({ type: String }) public placeholder!: string;
  @Prop() public options!: string[];
  @Prop() public presentation!: string[];
  @Prop({ type: Boolean, default: false }) public disabled?: boolean;

  public optionsList: object[] = null;
  public selected: string[] = [];

  public beforeMount() {
    this.loadOptions();
  }

  @Watch('options')
  public loadOptions() {
    if (this.options) {
      this.optionsList = [];
      for (const i of Object.keys(this.options)) {
        this.optionsList.push({
          key: this.options[i],
          value: this.options[i],
          text: this.presentation[i]
        });
      }
      this.selected = this.select;
    }
  }

  @Watch('selected')
  public updateText() {
    this.$emit('update', this.selected);
  }

  @Watch('select')
  public updateSelectedText() {
    this.selected = this.select;
  }
}
